/* eslint-disable */
import React, { useEffect } from 'react'
import SideBarOfViewCourse from '../components/core/viewCourse/SideBarOfViewCourse'
import {
    Outlet,
    useLocation,
    useParams
} from 'react-router-dom';
import CourseReviewModal from '../components/core/viewCourse/CourseReviewModal';
import { useDispatch, useSelector } from 'react-redux';
import { getCompleteCourse } from '../services/operations/courseApi';
import {
    setActiveSectionId,
    setActiveSubSectionId,
    setCourseSectionData,
    setEntireCourseData,
    setTotalNoOfLectures,
    setViewCourseLoading,
    updateCompletedLectures
} from '../redux/slices/viewCourseSlice';
import Loading from './Loading';

const ViewCourse = () => {
    const dispatch = useDispatch();
    const { viewCourseLoading, reviewModal } = useSelector(state => state.viewCourse);
    const { user } = useSelector(state => state.profile);
    const location = useLocation();
    const { courseId, sectionId, subSectionId } = useParams();
    const {
        courseSectionData,
        courseEntireData,
    } = useSelector(state => state.viewCourse);

    useEffect(() => {
        ; (() => {
            if (!courseSectionData.length) return;
            for (const course of user.courseProgresses) {
                if (course.courseId === courseId) {
                    dispatch(updateCompletedLectures(course?.completedVideos))
                }
            }
            const currentSectionIndex = courseSectionData.findIndex(
                (section) => section._id === sectionId
            );
            const currentSubSectionIndex = courseSectionData[currentSectionIndex]?.subSection.findIndex(
                (subsection) => subsection._id === subSectionId
            );
            const activeSection = courseSectionData?.[currentSectionIndex];
            const activeSubSection = activeSection?.subSection?.[currentSubSectionIndex];
            dispatch(setActiveSectionId(activeSection?._id));
            dispatch(setActiveSubSectionId(activeSubSection?._id));
        })();
    }, [location, courseEntireData, courseSectionData, user]);

    useEffect(() => {
        const setCourseSpecificDetails = async () => {
            dispatch(setViewCourseLoading(true));
            try {
                const courseResponse = await getCompleteCourse(courseId);
                dispatch(setEntireCourseData(courseResponse?.completeCourse));
                dispatch(setCourseSectionData(courseResponse?.completeCourse?.courseContent));
                dispatch(
                    setTotalNoOfLectures(
                        courseResponse.completeCourse?.courseContent
                            .flatMap((section) => section.subSection)
                            .reduce((accumulator) => accumulator + 1, 0)
                    )
                )
            } catch (error) {
                console.log('Error in ViewCourse component ', error.message);
            } finally {
                dispatch(setViewCourseLoading(false));
            }
        }
        setCourseSpecificDetails();
    }, [user, courseId, dispatch])
    if (viewCourseLoading) {
        return <div className='h-screen w-screen'>
            <Loading />
        </div>
    }

    return (
        <div className='relative flex min-h-[calc(100vh-3.5rem)] mt-14'>
            <SideBarOfViewCourse />
            <div className='w-full bg-richblack-800 overflow-y-auto'>
                <div className='w-full'>
                    <Outlet />
                </div>
            </div>
            {
                reviewModal && <CourseReviewModal />
            }
        </div>
    )
}

export default ViewCourse;